module.exports = __webpack_public_path__ + "static/media/bg-tubus.2121ee3f.png";